<div class="popup unauthorized-user-popup">
  <app-button [buttonStyle]="BUTTON_STYLES.UNSTYLED"
              (click)="close()"
              class="unauthorized-user-popup__close-btn">

    <app-icon [name]="ICONS.CLOSE"></app-icon>
  </app-button>

  <img src="/assets/images/spocaboo_logo_icon.svg" class="unauthorized-user-popup__logo">

  <h3 class="unauthorized-user-popup__title">{{ title }}</h3>

  <div class="unauthorized-user-popup__help-text">{{ helpText }}</div>

  <app-button [buttonStyle]="BUTTON_STYLES.ACTION"
              (click)="goToSignUpPage()"
              class="unauthorized-user-popup__action-btn">

    {{ 'sign_up' | t }}
  </app-button>
</div>
